// extracted by mini-css-extract-plugin
export default {"title":"Paa-z","warning":"Qaa-z","sizeOptionsLegendText":"Raa-z"};